import TabGroup from './tab-group.element.js';

export default TabGroup;

TabGroup.define('wje-tab-group', TabGroup);
